import { Sentry } from '@opendoor/observability';

/**
 * Users are encouraged to use try/catch clauses in their sagas.
 *
 * However, if they do not, or an unexpected exception occurs,
 * we set up the saga middleware with this handler as the handler
 * of last resort:
 *
 * const sagaMiddleware = createSagaMiddleware({ onError: sagaMiddlewareErrorHandler });
 */
export const sagaMiddlewareErrorHandler = (error: Error) => {
  Sentry.withScope((scope) => {
    scope.setTag('source', 'saga');
    Sentry.captureException(error);
  });
};
